import React from 'react';
import { assign, pick, keys, isArray } from 'lodash';
import './Select.css';

const $ = window.$;

class Select extends React.Component {
  constructor(props) {
    super(props);
    this.eId = props.id || `select_${ Math.round(Math.random()*1000000) }`;
  }

  getOptions() {
    const defaults = {
      disabled: false,
      placeholder: '',
      allowClear: false,
      minimumResultsForSearch: 10
    };

    let options = assign(defaults, pick(this.props, keys(defaults)));

    if (this.props.url) {
      options = {
        ...options,
        ajax: {
          cache: true,
          delay: 250,
          dataType: 'json',
          processResults: (data, params) => ({ results: data }),
          ...pick(this.props, [
            'url', 'cache', 'dataType', 'delay', 'data', 'processResults'
          ])
        },
        escapeMarkup: markup => markup,  // let Select2 custom formatter work
        minimumInputLength: this.props.minimumInputLength || 1,
        templateSelection: this.props.selectionTemplate ||
          (selectedOption => selectedOption.id || selectedOption.text),
        templateResult: this.props.optionTemplate || (val => <div>{ val }</div>)
      }
    }

    return options;
  }

  getSelectedOptions(e) {
    const { multiple } = this.props;

    if (multiple === "multiple") {
      const selected = [].slice.call(e.target.selectedOptions);
      return selected.map(option => option.value);
    } else {
      return e.target.value || "";
    }
  }

  renderOptions() {
    if (!this.props.options) {
      return null;
    }

    return this.props.options.map(option => (
      <option key={ option.key } value={ option.key }>
        { option.value }
      </option>
    ));
  }

  componentDidMount() {
    const { onChange, onSelect } = this.props;

    this.$node = $(this.refs.select2);
    this.$node.select2(this.getOptions());

    if (onChange) {
      this.$node.on("change", e => onChange(e, this.getSelectedOptions(e)));
    }

    if (onSelect) {
      this.$node.on("select2:select", e => onSelect(e, e.params.data));
    }
  }

  parseValue = () => {
    const { multiple, value } = this.props;

    if (multiple) {
      return isArray(value) ? value : [ value ];
    } else {
      return isArray(value) ? value[0] : value;
    }
  }

  render() {
    const { multiple, label } = this.props;

    return (
      <div>
        { label &&
          <label htmlFor={ this.eId }>{ label }</label>
        }
        <select id={ this.eId }
                className="form-control"
                ref="select2"
                multiple={ multiple || ""}
                value={ this.parseValue() }
                readOnly >
          <option value=""></option>
          { this.renderOptions() }
        </select>
      </div>
    );
  }

  componentWillUnmount() {
    // clean up the plugin mess when the component unmounts
    this.$node.off();  // just in case
    this.$node.select2('destroy');
  }
}

export default Select;



// WEBPACK FOOTER //
// ./src/components/Select/Select.js